import { css, useTheme } from '@mui/material'
import Link from 'next/link'
import { Fragment } from 'react'

import { Theme, themeUtils } from 'styles/theme'

interface BreadcrumbContent {
  link: string
  label: string | undefined
}

export default function Breadcrumb({
  data
}: {
  data: Array<BreadcrumbContent>
}) {
  const theme: Theme = useTheme()

  return (
    <div
      css={css`
        & a {
          text-decoration: none;
          margin: 0 16px;
          ${themeUtils.maxWidth.md} {
            margin: 0 8px;
          }
          ${themeUtils.maxWidth.sm} {
            padding: 0;
          }
        }
        & a:first-of-type {
          margin-left: 0;
        }
        ${themeUtils.maxWidth.md} {
          font-size: 14px;
        }
        ${themeUtils.maxWidth.sm} {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      `}
    >
      {data.map((elem, index) =>
        elem.label ? (
          <Fragment key={index}>
            <Link
              href={elem.link}
              passHref
              css={css`
                color: ${theme.palette.label.default};
              `}
            >
              {elem.label}
            </Link>

            {index !== data.length - 1 ? <span>{'>'}</span> : null}
          </Fragment>
        ) : null
      )}
    </div>
  )
}
